export function toBackendDate(date: Date = new Date()): string {
  return date.toISOString().replace("Z", "000Z");
}
